export const CMS_COMPONENTS = {
  PRODUCT_BANNERS: {
    EXTRA_LARGE: 'product-banners.extra-large',
    LARGE: 'product-banners.large',
  },
  SHARED: {
    STORE_SPECIAL_BANNER: 'shared.store-header',
    TRENDING_PRODUCTS: 'shared.trending-products',
    WHY_BUY_FROM_US: 'shared.why-buy-from-us',
    WHY_BUY_FROM_US_V2: 'shared.why-buy-from-us-v2',
    ACCORDION: 'shared.accordion',
    SEO_CONTENT: 'shared.seo-content',
    PLP: 'shared.plp',
    RECENTLY_VIEWED: 'shared.recently-viewed',
    NEED_HELP_WITH_DEVICE: 'shared.need-help-with-device',
    NEW_LAUNCHES: 'shared.new-launches',
    APP_DOWNLOAD_CARD: 'shared.app-download-card',
    HTML: 'shared.html',
    BANNER: 'shared.banner',
    HERO_BANNER: 'shared.hero-banner',
    TITLE: 'shared.title',
    VIDEO_CARD: 'shared.video-card',
    EXPERT_GUIDANCE_DEMO: 'shared.expert-guidance-demo',
    DYNAMIC_PLACEHOLDER: 'shared.dynamic-placeholder',
    TITLE_BANNER: 'shared.title-banner',
    CATEGORIES: 'shared.categories',
    TESTIMONIAL: 'shared.testimonial',
    STEPS: 'shared.steps',
    VIDEO_TUTORIALS: 'shared.video-tutorials',
    CATEGORIES_LIST: 'shared.categories-list',
  },
  BANNERS: {
    MEDIA_CAROUSEL: 'banners.media-carousel',
    SINGE_IMAGE: 'banners.single-image',
    TABULAR_TABS: 'banners.tabular-tabs',
  },
  AMC: {
    SERVICE_AND_FILTERS: 'amc.service-and-filters',
  },
  STATIC: {
    IMAGE_BANNER: 'static.image-banner',
    BENEFIT_CARD: 'static.benefit-card',
  },
  BLOG: {
    BLOG_LISTING: 'blog.blog-listing',
  },
  PRODUCT: {
    A_PLUS_CONTENT: 'product.a-content',
  },
  INVESTOR_RELATION: {
    ANNUAL_REPORTS: 'investor-relation.annual-reports',
    FINANCIAL_RESULTS: 'investor-relation.financial-results',
    MEDIA_COVERAGE: 'investor-relation.media-coverage',
    CONTACT_DETAILS: 'investor-relation.contact-details',
    LINKS: 'investor-relation.links',
    ABOUT_US: 'shared.about-us',
    SUBSIDIARY_FINANCIALS: 'investor-relation.subsidiary-annual-account',
    VISION: 'shared.vision',
  },
};
